import SVGLoader, { SVGLoaderProps } from './SVGLoader';

const FilterIcon = (props: SVGLoaderProps) => {
  const {
    width = 17,
    height = 17,
    viewboxWidth = 17,
    viewboxHeight = 17,
  } = props;

  return (
    <SVGLoader
      {...props}
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
    >
      <path
        d="M15.1718 4.65975H0.828157C0.608516 4.65975 0.397871 4.57232 0.242562 4.41668C0.0872522 4.26105 0 4.04997 0 3.82987C0 3.60978 0.0872522 3.3987 0.242562 3.24306C0.397871 3.08743 0.608516 3 0.828157 3H15.1718C15.3915 3 15.6021 3.08743 15.7574 3.24306C15.9127 3.3987 16 3.60978 16 3.82987C16 4.04997 15.9127 4.26105 15.7574 4.41668C15.6021 4.57232 15.3915 4.65975 15.1718 4.65975Z"
        fill="currentColor"
      />
      <path
        d="M10.6584 13H5.34165C5.12201 13 4.91136 12.9125 4.75605 12.7569C4.60074 12.6013 4.51349 12.3902 4.51349 12.1701C4.51349 11.95 4.60074 11.7389 4.75605 11.5833C4.91136 11.4276 5.12201 11.3402 5.34165 11.3402H10.6584C10.8781 11.3402 11.0887 11.4276 11.244 11.5833C11.3993 11.7389 11.4866 11.95 11.4866 12.1701C11.4866 12.3902 11.3993 12.6013 11.244 12.7569C11.0887 12.9125 10.8781 13 10.6584 13Z"
        fill="currentColor"
      />
      <path
        d="M13.2257 8.82577H2.77432C2.55468 8.82577 2.34404 8.73833 2.18873 8.5827C2.03342 8.42707 1.94617 8.21599 1.94617 7.99589C1.94617 7.77579 2.03342 7.56471 2.18873 7.40908C2.34404 7.25345 2.55468 7.16602 2.77432 7.16602H13.2257C13.4453 7.16602 13.656 7.25345 13.8113 7.40908C13.9666 7.56471 14.0538 7.77579 14.0538 7.99589C14.0538 8.21599 13.9666 8.42707 13.8113 8.5827C13.656 8.73833 13.4453 8.82577 13.2257 8.82577Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default FilterIcon;
